/** `sections/article-grid.liquid` — `<article-grid>`: progressive "load more"
 *  pagination (Figma 6431:18287).
 *
 *  Articles past the initial page are server-rendered with the
 *  `article-card-hidden` class. Each "Load more" click reveals the next
 *  `data-per-page` batch of cards and hides the button once every card is
 *  shown. Works for both the current-blog and merged all-articles lists.
 */

const HIDDEN_SELECTOR = '.article-card-hidden'
const BUTTON_SELECTOR = '[data-load-more]'
const HIDDEN_CLASS = 'article-card-hidden'

class ArticleGrid extends HTMLElement {
  #abort
  #button
  #perPage

  connectedCallback() {
    this.#button = this.querySelector(BUTTON_SELECTOR)
    if (!this.#button) return

    this.#perPage = Number.parseInt(this.dataset.perPage, 10) || 8
    if (this.#perPage < 1) this.#perPage = 1

    this.#abort = new AbortController()
    this.#button.addEventListener('click', this.#onLoadMore, { signal: this.#abort.signal })
    this.#syncButton()
  }

  disconnectedCallback() {
    this.#abort?.abort()
  }

  #onLoadMore = () => {
    const hidden = this.querySelectorAll(HIDDEN_SELECTOR)
    const reveal = Math.min(this.#perPage, hidden.length)
    for (let i = 0; i < reveal; i += 1) {
      hidden[i].classList.remove(HIDDEN_CLASS)
    }
    // Move focus to the first newly revealed card for keyboard users.
    hidden[0]?.querySelector('a')?.focus()
    this.#syncButton()
  }

  #syncButton() {
    this.#button.hidden = this.querySelectorAll(HIDDEN_SELECTOR).length === 0
  }
}

if (!customElements.get('article-grid')) {
  customElements.define('article-grid', ArticleGrid)
}
